import Glide from '@glidejs/glide';

export default class Autoplay {
  constructor(element) {
    this.element = element;
	 this.interval = element.dataset.interval;
	 this.options = {
		autoplay: this.interval,
		perView: 1,
		hoverpause: false,
		swipeThreshold: false,
		dragThreshold: false,
		animationDuration: 0,
		rewindDuration: 0,
		gap: 0
	};

    this.init();
  }

  init() {
		new Glide(this.element, this.options).mount();
  }
}
